export default __webpack_public_path__ + "static/media/seb_hover.f08d69ed.png";